import React, { useEffect, useRef } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import { UserContextProvider } from './UserContext';
import { Error } from './pages/Error';
import { DisplayApp } from './display/DisplayApp';
import { isDisplayPath } from './display/displayConfig';
import { useMsal } from '@azure/msal-react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

const AppWrapper = () => {
	const { instance, accounts, inProgress } = useMsal();
	const location = useLocation();
	const loginInitiated = useRef(false);
	const onDisplay = isDisplayPath(location.pathname);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	useEffect(() => {
		if (onDisplay) return undefined;

		const handleAuth = async () => {
			try {
				if (
					accounts.length === 0 &&
					inProgress === InteractionStatus.None &&
					!loginInitiated.current
				) {
					loginInitiated.current = true;
					await instance.loginRedirect({
						scopes: ['user.read'],
					});
				}
			} catch (error) {
				console.error('Authentication error:', error);
				loginInitiated.current = false;
			}
		};

		handleAuth();
		return undefined;
	}, [accounts, instance, inProgress, onDisplay]);

	return (
		<Routes>
			<Route path="/display/:token/*" element={<DisplayApp />} />
			<Route path="/error" element={<Error />} />
			<Route
				path="*"
				element={
					<>
						<UnauthenticatedTemplate>No Users Logged In</UnauthenticatedTemplate>
						<AuthenticatedTemplate>
							<UserContextProvider>
								<App />
							</UserContextProvider>
						</AuthenticatedTemplate>
					</>
				}
			/>
		</Routes>
	);
};

export default AppWrapper;
